export const generatePermalinkWithDiscount = (variantId: string, quantity: number, discountCode: string) => {
  const cartURL = `cart/${variantId}:${quantity}?discount=${discountCode}`;
  return cartURL;
};
